import createReducer from 'lib/create-reducer'
import { constants } from './actions'
import saga from './sagas'

export const defaultState = {
  mode: 'beginResetPassword',
  email: {
    type: 'email',
    placeholder: 'Email',
    value: ''
  },
  password: {
    type: 'password',
    placeholder: 'Password',
    value: ''
  },
  repeatPassword: {
    type: 'password',
    placeholder: 'Repeat Password',
    value: ''
  },
  resetPasswordToken: '',
  loading: false,
  resetPasswordExpired: false,
  resetPasswordSuccess: false,
  resetPasswordLinkNotFound: false,
  resetPasswordNotFound: false
}

const resetPasswordModal = createReducer(defaultState, {
  [constants.SET_RESET_PASSWORD_MODE]: (state, mode) => ({
    ...state,
    mode
  }),
  [constants.SET_RESET_PASSWORD_TOKEN]: (state, resetPasswordToken) => ({
    ...state,
    resetPasswordToken: resetPasswordToken
  }),
  [constants.SET_RESET_PASSWORD_FIELD]: (state, { field, value }, error) => {
    const nextState = {
      ...state,
      [field]: {
        ...state[field],
        value,
        error: !!error,
        errorMessage: error && error.message
      }
    }

    if (field === 'email') {
      nextState[field].value = value.toLowerCase()
    }

    if ((field === 'password' || field === 'repeatPassword') &&
        state.password.value &&
        state.repeatPassword.value
    ) {
      const passwordsMatch = nextState.password.value === nextState.repeatPassword.value
      const repeatPassword = {
        error: !passwordsMatch,
        errorMessage: 'Passwords must match'
      }
      nextState.repeatPassword = Object.assign({}, nextState.repeatPassword, repeatPassword)
    }
    return nextState
  },
  [constants.RESET_PASSWORD_SUBMIT]: state => ({
    ...state,
    loading: true
  }),
  [constants.RESET_PASSWORD_LINK_SENT]: state => ({
    ...state,
    password: {
      ...state.password,
      value: ''
    },
    repeatPassword: {
      ...state.repeatPassword,
      value: ''
    },
    loading: false,
    resetPasswordToken: '',
    resetPasswordLinkSent: true,
    resetPasswordSuccess: false,
    resetPasswordExpired: false,
    resetPasswordLinkNotFound: false,
    resetPasswordNotFound: false
  }),
  [constants.RESET_PASSWORD_SUBMIT_SUCCESS]: state => ({
    ...state,
    password: {
      ...state.password,
      value: ''
    },
    repeatPassword: {
      ...state.repeatPassword,
      value: ''
    },
    loading: false,
    resetPasswordToken: '',
    resetPasswordLinkSent: false,
    resetPasswordSuccess: true,
    resetPasswordLinkNotFound: false,
    resetPasswordNotFound: false
  }),
  [constants.RESET_PASSWORD_SUBMIT_FAILURE]: state => ({
    ...state,
    loading: false,
    resetPasswordSuccess: false,
    resetPasswordExpired: false,
    resetPasswordLinkSent: false,
    resetPasswordLinkNotFound: false,
    resetPasswordNotFound: false
  }),
  [constants.RESET_PASSWORD_EXPIRED]: state => ({
    ...state,
    loading: false,
    resetPasswordExpired: true,
    resetPasswordSuccess: false,
    resetPasswordLinkSent: false,
    resetPasswordLinkNotFound: false,
    resetPasswordToken: '',
    resetPasswordNotFound: false
  }),
  [constants.RESET_PASSWORD_LINK_NOT_FOUND]: state => ({
    ...state,
    loading: false,
    resetPasswordLinkNotFound: true,
    resetPasswordExpired: false,
    resetPasswordSuccess: false,
    resetPasswordLinkSent: false,
    resetPasswordToken: '',
    resetPasswordNotFound: false
  }),
  [constants.RESET_PASSWORD_NOT_FOUND]: state => ({
    ...state,
    loading: false,
    resetPasswordLinkNotFound: false,
    resetPasswordExpired: false,
    resetPasswordSuccess: false,
    resetPasswordLinkSent: false,
    resetPasswordToken: '',
    resetPasswordNotFound: true
  }),
  [constants.RESET_PASSWORD_MODAL_STATE]: state => ({
    ...defaultState
  })
}, saga)

export default resetPasswordModal
